export default __webpack_public_path__ + "static/media/lawyers.056a208b.jpg";